<cs-item-list>
  <cs-item>
    <cs-label>Basic table with clickable rows:</cs-label>
  </cs-item>
  <cs-item vertical>
    <cs-table item-right style="--table-columns: minmax(0, 1fr) repeat(4, minmax(0, 1fr))" data-test="table-basic">
      <cs-table-row header>
        <cs-table-header-cell>DATE</cs-table-header-cell>
        <cs-table-header-cell>SET 1</cs-table-header-cell>
        <cs-table-header-cell>SET 2</cs-table-header-cell>
        <cs-table-header-cell>SET 3</cs-table-header-cell>
        <cs-table-header-cell>NOTES</cs-table-header-cell>
      </cs-table-row>

      <cs-table-row clickable (rowClick)="onTableRowClick(0)" [selected]="selectedTableRow === 0" data-test="table-row-0">
        <cs-table-cell>Wed, Aug 31</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell align="right">
          <div style="display: flex; gap: 8px; align-items: center; justify-content: flex-end;">
            <span>My shoulder...</span>
            <cs-icon name="caret-right"></cs-icon>
          </div>
        </cs-table-cell>
      </cs-table-row>

      <cs-table-row clickable (rowClick)="onTableRowClick(1)" [selected]="selectedTableRow === 1" data-test="table-row-1">
        <cs-table-cell>Wed, Aug 31</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell align="right">
          <div style="display: flex; gap: 8px; align-items: center; justify-content: flex-end;">
            <span>Next time...</span>
            <cs-icon name="caret-right"></cs-icon>
          </div>
        </cs-table-cell>
      </cs-table-row>

      <cs-table-row clickable (rowClick)="onTableRowClick(2)" [selected]="selectedTableRow === 2" data-test="table-row-2">
        <cs-table-cell>Wed, Aug 31</cs-table-cell>
        <cs-table-cell>
          <div>70kg x</div>
          <div style="color: var(--text-tertiary);">12+11+11+10+9+9</div>
        </cs-table-cell>
        <cs-table-cell>
          <div>70kg x</div>
          <div style="color: var(--text-tertiary);">12+11+11+10+9+9</div>
        </cs-table-cell>
        <cs-table-cell>
          <div>70kg x</div>
          <div style="color: var(--text-tertiary);">12+11+11+10+9+9</div>
        </cs-table-cell>
        <cs-table-cell align="right">
          <div style="display: flex; gap: 8px; align-items: center; justify-content: flex-end;">
            <span>This time...</span>
            <cs-icon name="caret-right"></cs-icon>
          </div>
        </cs-table-cell>
      </cs-table-row>

      <cs-table-row clickable (rowClick)="onTableRowClick(3)" [selected]="selectedTableRow === 3" data-test="table-row-3">
        <cs-table-cell>Wed, Aug 31</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell>75lb x 6+6</cs-table-cell>
        <cs-table-cell align="right">
          <div style="display: flex; gap: 8px; align-items: center; justify-content: flex-end;">
            <cs-icon name="caret-right"></cs-icon>
          </div>
        </cs-table-cell>
      </cs-table-row>

      <cs-table-row clickable (rowClick)="onTableRowClick(4)" [selected]="selectedTableRow === 4" data-test="table-row-4">
        <cs-table-cell>Wed, Aug 31</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell>80lb, 75lb x 4+3</cs-table-cell>
        <cs-table-cell align="right">
          <div style="display: flex; gap: 8px; align-items: center; justify-content: flex-end;">
            <span>Note about...</span>
            <cs-icon name="caret-right"></cs-icon>
          </div>
        </cs-table-cell>
      </cs-table-row>
    </cs-table>
  </cs-item>
  <cs-item>
    <cs-note item-right>Click rows to select. Selected row: {{ selectedTableRow ?? 'none' }}</cs-note>
  </cs-item>
  <cs-item>
    <cs-note item-right>Features: CSS Subgrid for column alignment, zebra striping, hover states, and clickable rows.</cs-note>
  </cs-item>
</cs-item-list>
